// extracted by mini-css-extract-plugin
export default {"text":"styles_text__lR3xd","textRight":"styles_textRight__O7x86","textAnimated":"styles_textAnimated__chsM9","fade-in":"styles_fade-in__QvRjJ"};